import React, { useCallback, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import NewsieTakeawayPoint from "../NewsieTakeawayPoint";
import { setPuzzleAndPuzzleType } from "Store/features/puzzleSlice";

import "./NewsieTakeawayPointEditor.css";

const NewsieTakeawayPointsEditor = (props) => {
  const dispatch = useDispatch();
  const { selectedNewsie } = props;

  const puzzleSlice = useSelector((state) => state.puzzleSlice);

  const [editorSelectedWordCoordinates, setEditorSelectedWordCoordinates] =
    useState(null);

  const [editorSelectedTakeawayIndex, setEditorSelectedTakeawayIndex] =
    useState(null);

  const [editorSelectedTakeawayText, setEditorSelectedTakeawayText] =
    useState(null);

  const [selectedEditorWord, setSelectedEditorWord] = useState("");

  useEffect(() => {
    console.log("editorSelectedWordCoordinates", editorSelectedWordCoordinates);
  }, [editorSelectedWordCoordinates]);

  const handleSelectEditorTakeaway = useCallback((takeawayIndex, word) => {
    setEditorSelectedTakeawayIndex(takeawayIndex);
    setEditorSelectedTakeawayText(word);
  }, []);

  const handleSelectEditorWord = useCallback((columnIndex, wordIndex, word) => {
    setEditorSelectedWordCoordinates({ columnIndex, wordIndex });
    setSelectedEditorWord(word);
  }, []);

  const handleAddNewTakeaway = useCallback(() => {
    const newTakeawayPoints = selectedNewsie?.takeawayPoints
      ? [...selectedNewsie?.takeawayPoints, "This is a new takeaway point"]
      : ["This is a new takeaway point"];
    const newNewsieInput = selectedNewsie?.newsieInput.map((col) => {
      return [...col, ""];
    });
    dispatch(
      setPuzzleAndPuzzleType({
        ...puzzleSlice,
        puzzle: {
          ...selectedNewsie,
          takeawayPoints: newTakeawayPoints,
          newsieInput: newNewsieInput,
        },
      })
    );
  }, [dispatch, puzzleSlice, selectedNewsie]);

  const handleDeleteTakeaway = useCallback(
    (index) => {
      const newTakeawayPoints = selectedNewsie?.takeawayPoints.filter(
        (p, i) => i !== index
      );
      const newNewsieInput = selectedNewsie?.newsieInput.map((col) => {
        return col.filter((word, i) => i !== index);
      });
      dispatch(
        setPuzzleAndPuzzleType({
          ...puzzleSlice,
          puzzle: {
            ...selectedNewsie,
            takeawayPoints: newTakeawayPoints,
            newsieInput: newNewsieInput,
          },
        })
      );
    },
    [dispatch, puzzleSlice, selectedNewsie]
  );

  const handleSaveSelectedWord = useCallback(() => {
    const newNewsieInput = selectedNewsie?.newsieInput.map((col, colIndex) => {
      return col.map((word, wordIndex) => {
        if (
          colIndex === editorSelectedWordCoordinates.columnIndex &&
          wordIndex === editorSelectedWordCoordinates.wordIndex
        ) {
          return selectedEditorWord;
        }
        return word;
      });
    });

    dispatch(
      setPuzzleAndPuzzleType({
        ...puzzleSlice,
        puzzle: {
          ...selectedNewsie,
          newsieInput: newNewsieInput,
        },
      })
    );
    setEditorSelectedWordCoordinates(null);
  }, [
    dispatch,
    puzzleSlice,
    selectedNewsie,
    editorSelectedWordCoordinates,
    selectedEditorWord,
  ]);


  const handleSaveSelectedTakeawayText = useCallback(() => {
    const newTakeawayPoints = selectedNewsie?.takeawayPoints.map((p, i) => {
      if (i === editorSelectedTakeawayIndex) {
        return editorSelectedTakeawayText;
      }
      return p;
    });

    dispatch(
      setPuzzleAndPuzzleType({
        ...puzzleSlice,
        puzzle: {
          ...selectedNewsie,
          takeawayPoints: newTakeawayPoints,
        },
      })
    );
    setEditorSelectedTakeawayIndex(null);
    setEditorSelectedTakeawayText(null);
  }, [
    dispatch,
    puzzleSlice,
    selectedNewsie,
    editorSelectedTakeawayIndex,
    editorSelectedTakeawayText,
  ]);

  return (
    <div className="newsie-takeaway-points-editor-container">
      <div className="newsie-takeaway-points-editor-button-row-container">
        <div
          className="newsie-takeaway-points-editor-button"
          onClick={handleAddNewTakeaway}
        >
          Add Takeaway <b>+</b>
        </div>
      </div>
      {selectedNewsie?.takeawayPoints?.map((p, i) => {
        const takeAwayWords = selectedNewsie?.newsieInput?.map((col) => col[i]);
        return (
          <NewsieTakeawayPoint
            onSelectTakeaway={handleSelectEditorTakeaway}
            onChangeSelectedTakeawayText={setEditorSelectedTakeawayText}
            onSaveNewsieTakeawayText={handleSaveSelectedTakeawayText}
            selectedTakeawayIndex={editorSelectedTakeawayIndex}
            selectedTakeawayText={editorSelectedTakeawayText}
            onSelectEditorWord={handleSelectEditorWord}
            takeawayIndex={i}
            takeawayPoint={p}
            editorSelectedWordCoordinates={editorSelectedWordCoordinates}
            takeawayWords={takeAwayWords}
            selectedEditorWord={selectedEditorWord}
            onChangeSelectedWord={setSelectedEditorWord}
            onSaveSelectedWord={handleSaveSelectedWord}
            onClickDeleteTakeawayPoint={handleDeleteTakeaway}
          />
        );
      })}
    </div>
  );
};

export default NewsieTakeawayPointsEditor;
